import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { AlertModule } from 'ngx-alerts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CreditcardFormComponent } from './modules/admin/pages/form/creditcard-form/creditcard-form.component';

import { environment } from '../environments/environment';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { UserInfoEffects } from './core/store/user/effects/user.effects';
import { Customerror403Component } from './modules/admin/pages/error/customerror403/customerror403.component';
import { CommentEffects } from './core/store/user/effects/comment.effects';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TransactionTabEffects } from './core/store/user/effects/transaction-tab.effects';
import { EditTransactionFormSubmitEffects } from './core/store/user/effects/edit-transaction-form-submit.effect';
import { TransactionActionEffects } from './core/store/user/effects/transaction-actions.effects';
import { VerificationEffects } from './core/store/user/effects/verifications.effect';
import { AlertEffects } from './core/store/user/effects/alert.effects';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent, Customerror403Component],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),

        // Cashforo implement modules

        NgxSpinnerModule,
        AlertModule.forRoot({
            maxMessages: 5,
            timeout: 5000,
            positionX: 'right',
        }),
        EffectsModule.forRoot([
            UserInfoEffects,
            CommentEffects,
            TransactionTabEffects,
            EditTransactionFormSubmitEffects,
            TransactionActionEffects,
            VerificationEffects,
            AlertEffects,
        ]),
        StoreModule.forRoot(reducers, { metaReducers }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
